import DesignationAutocomplete from "./DesignationAutocomplete";
import { DatePicker } from "react-blueprint-library";
import moment from "moment";
import {Button} from "react-bootstrap";
import {isValidDate} from "../../../../common/Functions";

const DesignationRow = ({
                                  row,
                                  index,
                                  showHeader,
                                  availableDesignations,
                                  selectedDesignationIds,
                                  onUpdate,
                                  onRemove,
                                  disabled,
                              }) => {

    const getDateValue = () => {
        if (!row.issueDate || row.issueDate.includes("_")) {
            return null;
        }
        const parsed = moment(row.issueDate, "MM/DD/YYYY", true);
        return parsed.isValid() ? parsed.toDate() : null;
    };

    const validateDate = (dateValue) => {
        if (!dateValue || dateValue.includes("_")) {
            return { hasError: true, errorMessage: "Please enter a valid date" };
        }
        const currDate = moment();
        const dateParts = dateValue.split("/");
        const month = dateParts[0];
        const day = dateParts[1];
        const year = dateParts[2];
        const dateCalc = moment(year + "-" + month + "-" + day);
        const dif = currDate.diff(dateCalc, "year");

        if (!isValidDate(dateValue) || year === "0000") {
            return { hasError: true, errorMessage: "Please enter a valid date" };
        } else if (dif >= 100) {
            return { hasError: true, errorMessage: "Date cannot be more than 100 years ago" };
        } else if (dateCalc > currDate) {
            return { hasError: true, errorMessage: "Date cannot be a future date" };
        }
        return { hasError: false, errorMessage: "" };
    };

    const handleDateChange = (date) => {
        if (date) {
            const formattedDate = moment(date).format("MM/DD/YYYY");
            const { hasError, errorMessage } = validateDate(formattedDate);
            onUpdate(row.id, {
                issueDate: formattedDate,
                errors: {
                    ...row.errors,
                    issueDate: hasError,
                    issueDateText: errorMessage,
                },
            });
        } else {
            onUpdate(row.id, {
                issueDate: "",
                errors: {
                    ...row.errors,
                    issueDate: true,
                    issueDateText: "Please enter a valid date",
                },
            });
        }
    };


    const designationLabel = `Professional Designation${index > 0 ? ` ${index + 1}` : ""}`;

    return (
        <div style={{ marginBottom: "4px" }}>
            {showHeader &&
                <div className= "row col-md-12" style= {{marginBottom: "4px"}}>
                    <div className="col-md-6">
                        Professional Designation*
                    </div>
                    <div className="col-md-4">
                        Issue Date*
                    </div>
                    <div className="col-md-2"/>
                </div>
            }
            <div className= "row col-md-12" style= {{marginBottom: "12px"}}>
                <div className="col-md-6">
                    <DesignationAutocomplete
                        id={`designation-${row.id}`}
                        label={designationLabel}
                        value={row.designationName}
                        currentDesignationId={row.designationId}
                        availableDesignations={availableDesignations}
                        selectedDesignationIds={selectedDesignationIds}
                        onChange={(val) => {
                            if (val !== row.designationName) {
                                onUpdate(row.id, { designationName: val, designationId: null });
                            }
                        }}
                        onSelect={(d) => {
                            onUpdate(row.id, {
                                designationId: d.id,
                                designationName: d.name,
                                errors: {
                                    ...row.errors,
                                    designation: false,
                                    designationText: "",
                                },
                            });
                        }}
                        onClear={() =>
                            onUpdate(row.id, { designationId: null, designationName: "" })
                        }
                        onValidationError={(errorMessage) => {
                            onUpdate(row.id, {
                                errors: {
                                    ...row.errors,
                                    designation: !!errorMessage,
                                    designationText: errorMessage,
                                },
                            });
                        }}
                        hasError={row.errors.designation}
                        errorText={row.errors.designationText}
                        disabled={disabled}
                    />
                </div>
                <div className={`col-md-4 datepicker-wrapper ${row.errors.issueDate ? 'is-invalid' : ''} ${disabled ? 'datepicker-disabled' : ''}`}>
                    <DatePicker
                        disabled={disabled}
                        label=""
                        inputGroupClassName="date-picker-input"
                        placeholderText={"MM/DD/YYYY"}
                        selected={getDateValue()}
                        onChange={handleDateChange}
                        hasError={row.errors.issueDate}
                        errorText={row.errors.issueDateText}
                    />
                </div>
                <div className="col-md-2">
                    <Button
                        type="button"
                        variant={"link"}
                        onClick={() => onRemove(row.id)}
                        disabled={disabled}
                    >
                        Remove
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default DesignationRow;
